import { render, staticRenderFns } from "./fryer-only-frying-page.vue?vue&type=template&id=6ca7ac3e&scoped=true"
import script from "./fryer-only-frying-page.vue?vue&type=script&lang=js"
export * from "./fryer-only-frying-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca7ac3e",
  null
  
)

export default component.exports